import { useContext } from 'react'

import {
  IUserAuth0Context,
  UserAuth0Context
} from '@provider/Shared/UserAuthProvider'

export default function useUserAuth(): IUserAuth0Context {
  const context = useContext(UserAuth0Context)

  return context
}
